import { cx } from 'class-variance-authority';
import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
    containerClassNames,
    helperTextClassNames,
    inputContainerClassNames,
    labelClassNames
} from '~/components/ui/Form/StyledInput';

interface Option {
    value: string | number;
    label: string;
}

interface FormularSelectInputProps {
    name: string;
    label?: string;
    helperText?: string;
    options?: string[] | ((values: any) => string[]);
    optionsWithKey?: Option[];
    startsEmpty?: boolean;
}

const FormularSelectInput = ({
    name,
    label,
    helperText,
    options,
    optionsWithKey,
    startsEmpty = true
}: FormularSelectInputProps) => {
    const {
        register,
        formState: { errors },
        watch
    } = useFormContext();
    const { t } = useTranslation('common');
    const error = get(errors, name);
    const values = watch();
    const mappableOptions = typeof options === 'function' ? options(values) : options;

    return (
        <div className={containerClassNames({ fullWidth: true })}>
            {label && <label className={labelClassNames({ isInvalid: !!error })}>{label}</label>}
            <div
                className={inputContainerClassNames({
                    isInvalid: !!error,
                    className: 'tw-pr-2'
                })}
            >
                <select
                    {...register(name)}
                    name={name}
                    className="tw-h-full tw-w-full tw-flex-1 tw-cursor-pointer tw-border-none tw-bg-transparent tw-pr-6 tw-text-sm tw-outline-none"
                >
                    {startsEmpty && <option value="">{t('Bitte wählen ...', { ns: 'form' })}</option>}
                    {optionsWithKey
                        ? optionsWithKey.map((o, i) => (
                              <option key={`${name}_${i}_${o.value}`} value={o.value}>
                                  {t(o.label, { nsSeparator: null })}
                              </option>
                          ))
                        : mappableOptions?.map((o) => (
                              <option key={`${name}_${o}`} value={o}>
                                  {t(o, { nsSeparator: null })}
                              </option>
                          ))}
                </select>
            </div>
            {(error?.message || helperText) && (
                <span className={cx(helperTextClassNames({ isInvalid: !!error }))}>
                    {(error?.message as string) || helperText}
                </span>
            )}
        </div>
    );
};

export default FormularSelectInput;
